<template>
  <h1 class="title">{{ selected }}</h1>
  <div class="d1">
    <div class="d2">
      <div class="d2a" v-if="!isMobile">City Maps</div>
      <div class="d2b" v-if="!isMobile">        
        <ul>
          <li :class="key===selected? 'selectedCity': ''"  v-for="(val, key) in partners" :key="key" @click="selectCity(key)">{{ key }}</li>          
        </ul>
      </div>
      <div class="dropdown" v-if="isMobile" v-click-outside="onClickOutside">
        <button class="dropbtn" @click="showMenu = !showMenu" >{{ selected }} <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#e3e3e3"><path d="M480-120 300-300l58-58 122 122 122-122 58 58-180 180ZM358-598l-58-58 180-180 180 180-58 58-122-122-122 122Z"/></svg></button>
        <div :class="showMenu ? 'dropdown-content' : 'hide-dropdown'">
          <a v-for="(val,key) in partners" :key="key" @click="selectCity(key); showMenu=false;">{{ key }}</a>
        </div>
      </div>      
    </div>
    <div class="d3">
      <l-map ref="map"  class="d3a" style="height: 100% !important; width: 100% !important" @ready="onMapReady" :options="{ scrollWheelZoom: false }">
        <!-- style="height: 60vh !important; width: 100%;" -->
        <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <!-- ZIP code boundaries -->
        <l-geo-json
          v-for="zip in zipBoundaries"
          :key="zip.properties.ZCTA5CE10"
          :geojson="zip"
          :options-style="styleZip"          
        />

        <!-- ZIP code labels -->
        <l-marker
          v-for="zipLabel in zipLabels"
          :key="zipLabel.zipCode"
          :lat-lng="zipLabel.center"
          :options="zipLabel.options"
        />

        <!-- partner pins -->
        <l-marker
          v-for="(partner, index) in partners[selected]"
          :key="partner.fields.id"
          :lat-lng="[partner.fields.LatLon.lat, partner.fields.LatLon.lon]"
          :options="{
            ...partner.options,
            autoPan: false,
            closeButton: true
          }
          "
          :ref="el => { if (el) partnerMarkers[index] = el }"
          @mouseover="onMarkerMouseOver(index)"
          @mouseout="onMarkerMouseOut(index)"
        >
          <l-popup 
            :options="{ 
              closeButton: true, 
              autoClose: false, 
              closeOnClick: false,
              className: 'partner-popup'
            }"
          >
            <div 
              class="popup-content"
              @mouseenter="onPopupMouseEnter(index)"
              @mouseleave="onPopupMouseLeave(index)"
            >
              <h3 style="margin: 0 0 10px 0; color: #0077cc;">{{ partner.fields.partnerName }}</h3>
              <p style="margin: 5px 0;"><strong>Phone:</strong> {{ partner.fields.phone }}</p>
              <p style="margin: 5px 0;"><strong>Email:</strong> {{ partner.fields.email }}</p>
              <p style="margin: 5px 0;"><strong>Address:</strong><br>{{ partner.fields.address }}</p>
              <button 
                @click="navigateToPartner(partner)"
                style="
                  background: #0077cc;
                  color: white;
                  border: none;
                  padding: 8px 16px;
                  border-radius: 4px;
                  cursor: pointer;
                  margin-top: 10px;
                  font-weight: bold;
                "
                onmouseover="this.style.background='#005fa3'"
                onmouseout="this.style.background='#0077cc'"
              >
                View partner Details
              </button>
            </div>
          </l-popup>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<script>
// import { ref, onMounted, computed } from 'vue'
import {
  LMap,
  LTileLayer,
  LGeoJson,
  LMarker,
  LPopup
} from '@vue-leaflet/vue-leaflet'
import L from 'leaflet'

import 'leaflet/dist/leaflet.css'

import {client} from '../contentful';
export default {
  name: 'citymap',
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    LMarker,
    LPopup
  },
  data() {
    return {
      isMobile: false,
      minw: 0,
      partners: {},
      selected: 'Colorado Springs',
      cities: [],
      showMenu: false,
      
      // City coordinates will be calculated dynamically from GeoJSON boundaries
      
      // ZIP GeoJSON data loaded from file
      zipBoundaries: [],
      
      // partner markers ref for hover functionality
      partnerMarkers: [],
      
      // Track active popup
      activePopup: null,
      
      // Track if user is hovering over popup content
      isHoveringPopup: false,
      
      // Track if user is hovering over marker
      isHoveringMarker: false,
      
      // Store the Leaflet map instance
      mapInstance: null,      
    }
  },
  computed: {
    zipLabels() {
      if (!this.zipBoundaries || this.zipBoundaries.length === 0) {
        return []
      }
      
      return this.zipBoundaries.map(zip => {
        const coordinates = zip.geometry.coordinates[0]
        const center = this.calculateCentroid(coordinates)
        const zipCode = zip.properties.ZCTA5CE10
        
        // Safety check for valid coordinates
        if (!center || isNaN(center[0]) || isNaN(center[1])) {
          return null
        }
        
        return {
          zipCode,
          center,
          options: {
            icon: L.divIcon({
              className: 'zip-code-label',
              html: `<div style="
                font-weight: bold;
                font-size: 14px;
                color: #0077cc;
                text-shadow: 2px 2px 4px rgba(255,255,255,0.8);
                white-space: nowrap;
              ">${zipCode}</div>`,
              iconSize: [60, 20],
              iconAnchor: [30, 10]
            })
          }
        }
      }).filter(label => label !== null) // Remove any null entries
    }
  },
  methods: {
    onClickOutside() {
      this.showMenu=false;
    },
    windowSize () {
      if (window.innerWidth <= 900) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    updateViewport() {
      this.minw = window.screen.width*.75 + 'px';      
    },
    // Calculate centroid of polygon coordinates
    calculateCentroid(coordinates) {
      if (!coordinates || coordinates.length === 0) {
        return null
      }
      
      let x = 0
      let y = 0
      let len = coordinates.length
      
      for (let i = 0; i < len; i++) {
        if (coordinates[i] && coordinates[i].length >= 2) {
          x += coordinates[i][0]
          y += coordinates[i][1]
        }
      }
      
      if (len === 0) {
        return null
      }
      
      return [y / len, x / len] // [lat, lng]
    },
    // Load GeoJSON data from file
    async loadGeoData() {
      try {
        const fileName = this.selected.toLowerCase().replace(/ /g, '-') + '.geojson'
        const filePath = `/GeoData/${fileName}`
        console.log('Loading GeoJSON from:', filePath)
        
        const response = await fetch(filePath)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const data = await response.json()
        this.zipBoundaries = data.features
        console.log(`Loaded ${data.features.length} ZIP code boundaries`)
        
        // Auto-fit bounds to show all boundaries when data is loaded
        this.$nextTick(() => {
          if (this.mapInstance && this.zipBoundaries.length > 0) {
            const bounds = L.latLngBounds();
            this.zipBoundaries.forEach(zip => {
              if (zip.geometry && zip.geometry.coordinates) {
                if (zip.geometry.type === 'Polygon') {
                  zip.geometry.coordinates[0].forEach(coord => {
                    bounds.extend([coord[1], coord[0]]); // [lat, lng]
                  });
                } else if (zip.geometry.type === 'MultiPolygon') {
                  zip.geometry.coordinates.forEach(polygon => {
                    polygon[0].forEach(coord => {
                      bounds.extend([coord[1], coord[0]]); // [lat, lng]
                    });
                  });
                }
              }
            });
            
            // Fit the map to show all boundaries with some padding
            this.mapInstance.fitBounds(bounds, {
              padding: [20, 20], // Add 20px padding on all sides
              animate: false // No animation for initial load
            });
          }
        });
      } catch (error) {
        console.error('Error loading GeoJSON data:', error)
        // Set empty array as fallback
        this.zipBoundaries = []
      }
    },
    styleZip() {
      return {
        color: '#0077cc',
        weight: 2,
        fillColor: '#aaccee',
        fillOpacity: 0.2
      }
    },
    onZipClick(event) {
      const zipCode = event.target.feature.properties.ZCTA5CE10
      console.log(`Clicked on ZIP code: ${zipCode}`)
      // You can add additional functionality here, such as:
      // - Highlighting the clicked ZIP code
      // - Showing information about the ZIP code
      // - Filtering partners by ZIP code
    },
    navigateToPartner(partner) {
      window.location.href = `/partner/${partner.fields.slug}`
    },
    // Popup event handlers
    onMarkerMouseOver(index) {
      console.log(`Marker ${index} mouse over`)
      
      // Safety check - ensure the marker exists and has a leaflet object
      if (!this.partnerMarkers[index] || !this.partnerMarkers[index].leafletObject) {
        console.warn(`Marker ${index} not ready yet`)
        return
      }
      
      // Set marker hover state
      this.isHoveringMarker = true
      
      // Close any existing popup first
      if (this.activePopup !== null && this.activePopup !== index && this.partnerMarkers[this.activePopup] && this.partnerMarkers[this.activePopup].leafletObject) {
        this.partnerMarkers[this.activePopup].leafletObject.closePopup()
      }
      
      // Open popup on marker hover
      this.partnerMarkers[index].leafletObject.openPopup()
      this.activePopup = index
      this.isHoveringPopup = false
    },
    
    onMarkerMouseOut(index) {
      console.log(`Marker ${index} mouse out`)
      
      // Set marker hover state to false
      this.isHoveringMarker = false
      
      // Only close popup if we're not hovering over the popup content
      if (!this.isHoveringPopup) {
        setTimeout(() => {
          // Check if we're still not hovering over marker or popup before closing
          if (!this.isHoveringMarker && !this.isHoveringPopup && this.activePopup === index && this.partnerMarkers[index] && this.partnerMarkers[index].leafletObject) {
            console.log(`Closing popup for marker ${index}`)
            this.partnerMarkers[index].leafletObject.closePopup()
            this.activePopup = null
          }
        }, 300) // Reduced timeout for better responsiveness
      }
    },
    
    onPopupMouseEnter(index) {
      console.log(`Popup ${index} mouse enter`)
      // Keep popup open when hovering over content
      this.isHoveringPopup = true
      this.activePopup = index
    },
    
    onPopupMouseLeave(index) {
      console.log(`Popup ${index} mouse leave`)
      // Mark as not hovering over popup
      this.isHoveringPopup = false
      
      // Close popup after a shorter delay when leaving content
      setTimeout(() => {
        // Check if we're not hovering over marker or popup before closing
        if (!this.isHoveringMarker && !this.isHoveringPopup && this.activePopup === index && this.partnerMarkers[index] && this.partnerMarkers[index].leafletObject) {
          console.log(`Closing popup for marker ${index} after leaving content`)
          this.partnerMarkers[index].leafletObject.closePopup()
          this.activePopup = null
        }
      }, 200) // Reduced timeout for better responsiveness
    },
    selectCity(city){
      this.selected=city;
      this.loadGeoData();
      this.partnerMarkers = new Array(this.partners.length).fill(null)
      
      // The map will be centered automatically when loadGeoData() completes
      // and calls the bounds fitting logic
    },
    onMapReady(map) {
      console.log('Map is ready!');
      // Store the map instance and load GeoJSON data
      this.mapInstance = map;
      this.loadGeoData();
    }
  },
  created() {
    const contentfulClient = client;
    contentfulClient.getEntries( { content_type: 'cityMaps'}).then((response) => {  
      response.items.forEach((item) => {
        this.cities.push(item.fields.cityName);
      })
    })
    contentfulClient.getEntries( { content_type: 'partner'}).then((response) => {  
      response.items.forEach((item) => {
        if(!(item.fields.city in this.partners)){
          this.partners[item.fields.city] = [];
        }   
        this.partners[item.fields.city].push(item);
      })
      console.log(this.partners);
    });
  },
  mounted() {
    this.windowSize();
    window.addEventListener('resize', this.windowSize);

    this.updateViewport();    
    window.addEventListener('resize', this.updateViewport); 
    // Initialize partnerMarkers array with proper length
    this.partnerMarkers = new Array(this.partners.length).fill(null)
    
    // Debug: log the initialization
    console.log(`Initialized partnerMarkers array with length ${this.partners.length}`)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateViewport);
    window.removeEventListener('resize', this.windowSize);
  },
}
</script>

<style scoped>
.d1 {
  display: flex;  
  white-space: nowrap;
  /* margin: 35px; */
  width: 100%;
  justify-content: space-evenly;
  min-width: v-bind(minw);
}
.d2 {
  margin-right: 35px;
  margin-top: 100px;
}
.d2a, .d2b {
  font-family: 'Akatab';
  font-weight: 600;
  color: v-bind(colorRed);
  font-size: 32px;
}
.d2b {
  font-size: 20px;
}

.d2b > ul > li:hover {
  cursor: pointer;
  color: v-bind(colorBlue5);
}
.d2b > ul > li {
  margin-bottom: 10px;
}
.d3 {
  display: block;  
  width: 70em;
  height: 38em;
  border-radius: 10px !important;
  box-sizing: border-box;
  margin-bottom: 35px;
}
.d3a {
  border-radius: 10px;
  border: 3px solid v-bind(colorPurple);
  box-sizing: border-box;
}
.zip-code-label {
  background: transparent !important;
  border: none !important;
}

/* Ensure map takes full viewport */
:deep(.leaflet-container) {
  height: 100vh !important;
  width: 100vw !important;
}

/* Custom popup styles */
/* :deep(.partner-popup) {
  background: white;
  border: 2px solid #0077cc;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  font-size: 14px;
  line-height: 1.4;
  max-width: 250px;
  z-index: 1000;
} */

:deep(.partner-popup .leaflet-popup-content-wrapper) {
  background: white;
  border: 2px solid #0077cc;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  box-sizing: border-box;
  min-width: 250px;
  max-width: 350px;
}

:deep(.partner-popup .leaflet-popup-content) {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

:deep(.partner-popup .leaflet-popup-tip) {
  background: white;
  border: 2px solid #0077cc;
  border-top: none;
  border-left: none;
}

.leaflet-popup-pane {
  box-sizing:border-box;
}

.popup-content {
  pointer-events: auto;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.popup-content h3 {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.2;
}

.popup-content p {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  margin: 8px 0;
}

.popup-content button {
  pointer-events: auto;
}
.selectedCity {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.title {
  font-family: 'Anonymous Pro';
  font-size: 60px;
  color: v-bind(colorRed);
  position:absolute;
  min-width: v-bind(minw);
  top: 130px;
  display: flex;
  justify-content: center;
  width: 100%;
  text-shadow:0 4px 4px rgba(0, 0, 0, 0.35);
}

@media only screen and (max-width: 900px) {
  .d1 {
    flex-direction: column;
    align-items: center;
  }
  .d2 {
    margin-top:-30px;
    margin-right: 0;
    margin-bottom: 35px;

  }
  .d3 {
    width: 90%;
    height: 25em;    
  }
  /* .d3a {
    margin-right: 30px;
    margin-left:30px;
  } */
  .dropdown {
    position: relative;
    display: inline-block;
    min-width: 250px;
    font-family: 'Akatab';
  }
  .dropbtn {    
    background-color: v-bind(colorBlue2);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    height: 30px;
    width: 100%;    
    font-size: 1.2em;
    padding: 15px;
    border: 2px outset rgb(0,0,0);
  }
  .dropdown-content{   
    display: flex;
    flex-direction: column;
    position: absolute;
    background-color: v-bind(colorBlue2);    
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1001;
    width: 90%;
    margin-left:5%;
    color: white;    
    box-sizing: border-box;    
  }  
  .dropdown-content > a {
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid v-bind(colorBlue5);
  }
  .hide-dropdown {
    display: none;
  }  
  .title {
    position: relative;
    top:-60px;
    font-size: 50px;
    text-align: center;    
  }
}
</style>